export default "__VITE_ASSET__y8n2jKto__"